module.exports = __webpack_public_path__ + "media/man5.217b10dc.wav";